import { createEvent } from "library/local-events/index.mjs"

export const AI_MAPPING_FEEDBACK = "ai-mapping-feedback"

export const MappingFeedbackRecorded = createEvent("MappingFeedbackRecorded")
export const ReclassifyMappingFeedback = createEvent("ReclassifyMappingFeedback")
